import styled from "styled-components";
import { colorWhite, hex2rgba } from "../../colors";
import { BreakPoints, ContentWidths } from "../../constants";

export const StyledHero = styled.section.attrs({
  className: "hero-section"
})`

  color: ${colorWhite};
  font-family: Pitch Sans Bold;
  text-align: center;
  position: relative;

  .hero {
    background-size: cover;
    background-position: center;
    display: flex;
    justify-content: center;
    align-items: center;

    &__container {
      position: relative;
      width: 100%;
      margin: 32px 15px;
      border: 12px solid ${colorWhite};
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 60px 40px 56px;

      @media (min-width: ${BreakPoints.sm}) {
        width: ${ContentWidths.sm};
      }

      @media (min-width: ${BreakPoints.md}) {
        width: ${ContentWidths.md};
        border-width: 16px;
        padding: 76px 72px;
      }

      @media (min-width: ${BreakPoints.lg}) {
        width: ${ContentWidths.lg};
      }

      @media (min-width: ${BreakPoints.xl}) {
        width: ${ContentWidths.xl};
      }

      &:before,
      &:after {
        content: "";
        display: block;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        height: 24px;
        width: 12px;
        background-color: ${colorWhite};

        @media (min-width: ${BreakPoints.md}) {
          width: 16px;
          height: 40px;
        }
      }

      &:before {
        top: 0;
      }
      &:after {
        bottom: 0;
      }
    }

    &__label {
      display: none;

      @media (min-width: ${BreakPoints.md}) {
        font-size: .8125rem;
        font-weight: bold;
        text-transform: uppercase;
        letter-spacing: .2em;
        display: block;
        position: absolute;
        margin: 0;
        top: 50%;
        height: 100%;
        writing-mode: vertical-rl;
        color: ${hex2rgba(colorWhite, 0.6)};

        &--left {
          left: 20px;
          transform: translateY(-50%) rotate(180deg);
        }
        &--right {
          right: 20px;
          transform: translateY(-50%);
        }
      }
    }

    &__title {
      font-family: Kapra Neue Pro;
      font-size: 2.5rem;
      font-weight: normal;
      text-transform: uppercase;
      margin: 0 0 16px 0;

      @media (min-width: ${BreakPoints.sm}) {
        font-size: 4rem;
      }

      @media (min-width: ${BreakPoints.md}) {
        font-size: 7.5rem;
      }

      @media (min-width: ${BreakPoints.lg}) {
        margin-bottom: 0;
      }
    }

    &__subtitle {
      text-transform: uppercase;
      font-weight: 700;
      font-size: .8125rem;
      letter-spacing: .2em;
      margin: 0;
    }

    &__description { 
      display: none;

      @media (min-width: ${BreakPoints.lg}) {
        display: block;
        font-size: 1.25rem;
        margin: 16px 0;
        max-width: 600px;
      }

      @media (min-width: ${BreakPoints.xl}) {
        max-width: 730px;
      }
    }
  }
`;
